import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container } from "reactstrap";
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Badge,
    Label,
    Button,
    Form,
    Input,
    InputGroup,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
  } from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import { PENDING_LEAVE_REQUESTS, LEAVE_REQUESTS, COST_CENTERS, POSTED_LR } from '../../helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import Select from 'react-select';

    const LeaveRequests = () => {
      const history = useHistory();

      toastr.options = TOAST_OPTIONS;
      
      const [leaveRequests, setLeaveRequests] = useState([]);
      
      useEffect(() => {
        let obj = JSON.parse(localStorage.getItem("authMildUser"));
        let EmployeeNo = obj.uid;
        axios.get(LEAVE_REQUESTS+"?$filter=employeeNo eq '"+EmployeeNo+"'and status eq 'Open' &company="+ obj.activeCompany, HRConfig).then(function(response){
          setLeaveRequests(response.data.value);
        })
      }, []);

      const handleFilter = (e) => {
          e.preventDefault();
          let obj = JSON.parse(localStorage.getItem("authMildUser"));
          let EmployeeNo = obj.uid;
          let url = LEAVE_REQUESTS;
          const dateRange = document.getElementsByClassName('filterDate')[0]._flatpickr.selectedDates;
          const startDate = formatDate(dateRange[0]);
          const endDate = formatDate(dateRange[1]);
          const stat = document.getElementsByClassName('filterStatus')[0].value;
          
          let urlParams = '';
      
          if(stat != ''){
            urlParams = urlParams.concat( ` and Status eq '${stat}' `);
          }
 
          if(dateRange.length > 0){
            urlParams = urlParams.concat(` and ( From_Date ge ${startDate} and To_Date le ${endDate} )`);
          }
          url += `?$filter=Employee_No eq '${EmployeeNo}'`
          if(urlParams != ''){
            url += urlParams;
          }
          axios.get(url, HRConfig).then(function(response){    setLeaveRequests(response.data.value);    })
      }
      const handleStatusChanged = () => {
        const stat = document.getElementsByClassName('filterStatus')[0].value;
        stat === 'Approved' ? history.push("/posted-leave-requests") : ""
      }

      const handleDelete = row => {
        axios.delete(LEAVE_REQUESTS + "(" + row.SystemId + ")", HRConfig)
        .then(function(response){     
            if(response.status == '204'){
                toastr.success("Leave Request deleted" ); 
                let obj = JSON.parse(localStorage.getItem("authMildUser"));
                let EmployeeNo = obj.uid;
                axios.get(LEAVE_REQUESTS+"?$filter=Employee_No eq '"+EmployeeNo+"'", HRConfig).then(function(response){
                  setLeaveRequests(response.data.value);
                })
            }else{
                toastr.success("Could not Delete Leave Request" )
            }
        })
        .catch(function (error) {
            toastr.error(error.response.data.error.message);
            //console.log(error.response.data.error.message);
        })
        .then(function () {
        // always executed
        });
      }
      

      const { SearchBar } = Search;
      const columns = [
      {
        dataField: 'no',
        text: 'Leave No',
        sort: true,
        formatter: noFormatter
      },
      {
        dataField: 'employeeNo',
        text: 'Employee No',
        sort: true
      }, 
      {
        dataField: 'employeeName',
        text: 'Name',
        sort: true
      }, 

      {
        dataField: 'postingDate',
        text: 'Posting Date',
        sort: true
      },
      {
        dataField: 'departmentCode',
        text: 'Department Code',
        sort: true
      }, 
      {
        dataField: 'status',
        text: 'Status',
        sort: true,
        formatter: statusFormatter
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "",
        formatter: actionFormatter
      }];

      const defaultSorted = [{
        dataField: 'No',
        order: 'desc'
      }];

      function noFormatter(cellContent, row){
        return(
          <strong>{cellContent}</strong>
        )
      }
      function typeFormatter(cellContent, row){
        if(row.Annual_Leave_WS == 'Yes'){
          return(
            <strong>ANNUAL</strong>
          )
        }else if(row.Sick_Leave_WS == 'Yes'){
          return(
            <strong>SICK</strong>
          )
        }else if(row.Maternity_Leave_WS == 'Yes'){
          return(
            <strong>MATERNITY</strong>
          )
        }else if(row.Paternity_Leave_WS == 'Yes'){
          return(
            <strong>PATERNITY</strong>
          )
        }else if(row.Compassionate_Leave_WS == 'Yes'){
          return(
            <strong>COMPASSIONATE</strong>
          )
        }else if(row.Study_Leave_WS == 'Yes'){
          return(
            <strong>STUDY</strong>
          )
        }else{
          return(
            <strong>UNPAID</strong>
          )
        }
      }
      function actionFormatter(cellContent, row){
        return(
        <>
            <div className="d-flex gap-3">
            <UncontrolledDropdown direction="left">
                <DropdownToggle href="#" className="card-drop" tag="i">
                  <i className="mdi mdi-dots-horizontal font-size-18" />
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <DropdownItem
                    onClick={()=>{ history.push(`/leave-request-details/${row.SystemId}`); }}
                  >
                    <i className="fas fa-address-card text-warning me-1" />
                    Leave Request Details
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </>
        )
      }
      function statusFormatter(cellContent, row) {
        if (row.status == "Pending") {
          return (
            <div>
                <Badge className="me-2 bg-warning">
                { cellContent }
                </Badge>
            </div>
          );
        }else if (row.status == "Approved"){
          return (
            <div>
                <Badge className="me-2 bg-success">
                { cellContent }
                </Badge>
            </div>
          );
        }else{
          return (
            <div>
                <Badge className="me-2 bg-danger">
                { cellContent }
                </Badge>
            </div>
          );
        }
      }

        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Leave Requests | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Leave Requests" />
                    <Row>
          

            <Col lg={12}>
              <Card>
                <CardBody>
                   {leaveRequests && (leaveRequests.length > 0) && (
                    <ToolkitProvider
                      keyField="no"
                      data={ leaveRequests }
                      columns={ columns }
                      search
                    >
                      { toolkitProps => (
                          <React.Fragment>
                            <Row className="mb-2">
                              <Col sm="4">
                                <div className="search-box me-2 mb-2 d-inline-block">
                                  <div className="position-relative">
                                    <SearchBar {...toolkitProps.searchProps} />
                                    <i className="bx bx-search-alt search-icon" />
                                  </div>
                                </div>
                              </Col>
                              <Col sm="8">
                              <div className="text-sm-end">
                                  <Link
                                    className="btn btn-primary"
                                    to="/add-leave-request"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add Leave Request
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col xl="12">
                                
                              <div className="table-responsive">
                            
                                <BootstrapTable 
                                  keyField='No' 
                                  data={ leaveRequests } 
                                  columns={ columns } 
                                  striped
                                  hover
                                  condensed
                                  bordered={ false }
                                  noDataIndication="No Records" 
                                  defaultSorted={ defaultSorted }
                                  classes={ "table-sm align-middle table-wrap table-check" }
                                    {...toolkitProps.baseProps}
                                  />

                                </div>
                             
                             </Col>
                             </Row>
                             </React.Fragment>
                            
                      )
                    }
                  </ToolkitProvider>
                  )}
                  {leaveRequests && (leaveRequests.length < 1) && (
                    <div className="text-center">
                      <div className="mb-4">
                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                      </div>
                      <div>
                      <h5>No Leave Request Found</h5>
                      <p className="text-muted">
                              
                      </p>
                      </div>
                      <div className="text-center mt-4">
                          <Link
                           to="/add-leave-request"
                          //to="/coming-soon"
                          className="btn btn-primary  btn-sm"
                          >
                          Create Leave Request <i className="mdi mdi-arrow-right ms-1" />
                          </Link>
                      </div>
                  </div>

                  )}
                </CardBody>
              </Card>
            </Col>

            

          </Row>

                    </Container>
                </div>
            </>
        );
    }

export default LeaveRequests;